module.exports = __webpack_public_path__ + "static/media/exchange.a41856cf.png";